<template>
    <div>
        <Header />
        <div class="wrapper">
            <div class="main">

                <div class="results">
                    <div class="border-bottom"><span class="number-of-result">{{ total }}</span>件が該当しました</div>
                </div>

                <property-pagination
                    @clickPaginate="clickPaginate"
                    @changeLimit="changeLimit"
                    :pages="paginate"
                />

                <!-- 物件詳細 -->
                <section class="property-section bg-grey">
                    <property-list
                        v-for="property in properties"
                        :key="property.id"
                        :property="property"
                        @pushFavorite="favorite"
                        @share="share"
                    />
                </section>
            </div>

            <!-- サイドバー -->
            <sidebar-condition
                @search="search"
            />

        </div>
        <share-modal
            :dialogVisible="isShareModal"
            :property="shareProperty"
            @close="closeShareModal"
        />
    </div>
</template>

<script>
import Header from '../../components/Header/Header'
import PropertyList from '../../components/List/PropertyList'
import PropertyPagination from '../../components/Pagination/PropertyPagination'
import PropertyRepository from '../../backend/PropertyRepository'
import SidebarCondition from "../../components/Sidebar/SidebarCondition";
import ShareModal from '../../components/organisms/modal/ShareModal'

export default {
    name: 'favorite-list',
    components: {
        Header,
        PropertyList,
        PropertyPagination,
        SidebarCondition,
        ShareModal
    },
    data() {
        return {
            properties: [],
            total: 0,
            paginate: {},
            options: {
                newlyFrom: '',
                newlyTo: '',
                price_from: 0,
                price_to: 0,
                area: [],
                station_distance: 0,
                floor_area_ratio_from: 0,
                floor_area_ratio_to: 0,
                limit: 20,
                only_favorite: 1
            },
            isShareModal: false,
            shareProperty: null
        }
    },
    mounted() {
        this.getFavoriteProperties()
    },
    methods: {
        // お気に入り一覧を取得する
        async getFavoriteProperties(page = null) {
            const response = await PropertyRepository.getList(this.options, page)

            this.properties = response.data
            this.total = response.total
            this.paginate = response
        },
        // ページネーション押下
        clickPaginate(page) {
            this.getFavoriteProperties(page)
        },
        // 検索処理
        search(options) {
            this.options.newlyFrom = options.newlyFrom
            this.options.newlyTo = options.newlyTo
            this.options.price_from = options.priceFrom
            this.options.price_to = options.priceTo
            this.options.area = options.area
            this.options.station_distance = options.stationDistance
            this.options.floor_area_ratio_from = options.floorAreaRatioFrom
            this.options.floor_area_ratio_to = options.floorAreaRatioTo

            this.getFavoriteProperties()
        },
        // 表示件数の変更を感知
        changeLimit(limit) {
            this.options.limit = limit
        },
        // お気に入り
        async favorite(property) {
            const findProperty = (element) => element.id === property.id;
            const index = this.properties.findIndex(findProperty)
            let message = ''
            let response = ''

            // お気に入り解除
            if (property.favorites) {
                response = await PropertyRepository.unfavorite(property)
                message = 'お気に入りから削除しました'

            // お気に入り登録
            } else {
                response = await PropertyRepository.favorite(property)
                message = 'お気に入りに登録しました'
            }

            if (response.status === 200) {
                this.$message({
                    message: message,
                    type: 'success'
                })

                this.changeFavorite(index, property)
            }
        },
        // お気に入りの表示を切り替える
        changeFavorite(index, property) {
            this.properties[index].favorites = !property.favorites
        },
        // SNSシェア
        share(property) {
            this.isShareModal = true
            this.shareProperty = property
        },
        closeShareModal() {
            this.isShareModal = false
        }
    }
}
</script>


<style scoped>
.wrapper {
    width: 80%;
    display: flex;
    margin: 20px auto;
    justify-content: center;
}

.main {
    width: 95%;
    margin-right: 20px;
}
/*-------------result-------------------*/
.results {
    margin-bottom: 16px;
    text-align: left;
}

/*-------------result-------------------*/
.results {
    margin-bottom: 16px;
    text-align: left;
}

.border-bottom {
    border-bottom: 1px solid #707070;
}

.number-of-result {
    font-size: 30px;
    color: #FF3F3A;
}


@media screen and (max-width: 1000px) {

    .wrapper {
        width: 90%;
        flex-direction: column-reverse;
    }

    .main {
        width: 100%;
    }

    .side {
        margin-top: 100px;
        width: 100%;
    }

    .property-body {
        font-size: 10px;
    }

    .property-price {
        font-size: 15px;
    }
}


@media screen and (max-width: 600px) {
    .property-section {
        padding: 0;
    }

    .property-block {
        padding: 1rem 1rem 1rem 1rem;
    }

    .property-block figure {
        width: 115px;
        height: 100px;
    } 

    .property-thumb {
        width: 112px;
        height: 97px;
    }
}
</style>

<style>
.el-tabs{
    width: 100%;
}

</style>